// IMOTEpS — Centre de recherche (index)
// Source: synthèse Dr Richard Aswad, IMOTEpS 2026
// Refactor Feb 2026: each chapter lives in its own file under ./chapters/
// Public API preserved: CHAPTERS, CHAPTER_THEMES, groupByRegion

import { chapter01 } from "./chapters/chapter-01";
import { chapter02 } from "./chapters/chapter-02";
import { chapter03 } from "./chapters/chapter-03";
import { chapter04 } from "./chapters/chapter-04";
import { chapter05 } from "./chapters/chapter-05";
import { chapter06 } from "./chapters/chapter-06";
import { chapter07 } from "./chapters/chapter-07";
import { chapter08 } from "./chapters/chapter-08";
import { chapter09 } from "./chapters/chapter-09";
import { chapter10 } from "./chapters/chapter-10";
import { chapter11 } from "./chapters/chapter-11";
import { chapter12 } from "./chapters/chapter-12";

export const CHAPTER_THEMES = {
  5: { name: "Ocre cuivré", color: "#B5682A" },
  6: { name: "Vert sauge", color: "#2E7D6B" },
  7: { name: "Bordeaux prune", color: "#8B2252" },
  8: { name: "Bleu indigo", color: "#2D4B8C" },
  9: { name: "Vert forêt", color: "#3A6B35" },
  10: { name: "Brique terracotta", color: "#8B3A1A" },
  11: { name: "Violet améthyste", color: "#5B2D8C" },
  12: { name: "Orangé ambre", color: "#C45C00" },
};

export const CHAPTERS = [
  chapter01, chapter02, chapter03, chapter04,
  chapter05, chapter06, chapter07, chapter08,
  chapter09, chapter10, chapter11, chapter12,
];

// Helper: chapters grouped by region
export const groupByRegion = () => {
  const map = {};
  CHAPTERS.forEach((c) => {
    if (!map[c.region]) map[c.region] = [];
    map[c.region].push(c);
  });
  return map;
};
